import styled from 'styled-components';


export const Container = styled.div`
    display: flex;
    width: 100%;
    justify-content: flex-end;
    height: 5dvh;
    background: #E0ECFC;
`
export const FooterDiv = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    height: 100%;
`
export const Logo = styled.img`
    position: absolute;
    width: 40px;
    height: 40px;
    margin-top: -20px;
`